import { type PlanId } from './pricing'

export const UNLIMITED_LIMIT = 999999
export const AI_LIMIT_PER_SEAT = 'per_seat' as const

export interface PlanEntitlements {
  maxEvents: number
  maxProposals: number
  maxPackages: number
  canUseAddOns: boolean
  canUseWaitlist: boolean
  canUsePublicBookingPage: boolean
  canCustomizePublicPageTheme: boolean
  aiTokensMonthly: number | typeof AI_LIMIT_PER_SEAT
  usersLabel: string
  currenciesLabel: string
}

export const PLAN_ENTITLEMENTS: Record<PlanId, PlanEntitlements> = {
  free: {
    maxEvents: 1,
    maxProposals: 5,
    maxPackages: 1,
    canUseAddOns: false,
    canUseWaitlist: false,
    canUsePublicBookingPage: false,
    canCustomizePublicPageTheme: false,
    aiTokensMonthly: 0,
    usersLabel: '1 usuário',
    currenciesLabel: 'USD',
  },
  starter: {
    maxEvents: 4,
    maxProposals: 30,
    maxPackages: 3,
    canUseAddOns: false,
    canUseWaitlist: false,
    canUsePublicBookingPage: false,
    canCustomizePublicPageTheme: false,
    aiTokensMonthly: 5,
    usersLabel: '1 usuário',
    currenciesLabel: 'USD + BRL',
  },
  pro: {
    maxEvents: 12,
    maxProposals: 100,
    maxPackages: 5,
    canUseAddOns: true,
    canUseWaitlist: true,
    canUsePublicBookingPage: true,
    canCustomizePublicPageTheme: true,
    aiTokensMonthly: 50,
    usersLabel: '3 usuários',
    currenciesLabel: 'USD + BRL + EUR',
  },
  studio: {
    maxEvents: UNLIMITED_LIMIT,
    maxProposals: UNLIMITED_LIMIT,
    maxPackages: UNLIMITED_LIMIT,
    canUseAddOns: true,
    canUseWaitlist: true,
    canUsePublicBookingPage: true,
    canCustomizePublicPageTheme: true,
    aiTokensMonthly: AI_LIMIT_PER_SEAT,
    usersLabel: '10+ usuários',
    currenciesLabel: 'USD + BRL + EUR',
  },
}

export function getPlanEntitlements(planId: PlanId): PlanEntitlements {
  return PLAN_ENTITLEMENTS[planId]
}

export function resolvePlanAiLimit(planId: PlanId, seats: number): number {
  const entitlement = PLAN_ENTITLEMENTS[planId]
  if (entitlement.aiTokensMonthly === AI_LIMIT_PER_SEAT) {
    return Math.max(1, seats) * 100
  }
  return entitlement.aiTokensMonthly
}

export function isUnlimitedLimit(value: number): boolean {
  return value >= UNLIMITED_LIMIT
}
